export function logAction(...msgs: any[]) {
  const style = "background: rgb(248, 177, 173); color: rgb(63, 172, 203)"
  console.log(`%c ${msgs}`, style)
}

export function logYellow(...msgs: any[]) {
  const style = "background: yellow; color: red"
  console.log(`%c ${msgs}`, style)
}

export function logRed(...msgs: any[]) {
  const style = "background: red; color: white"
  console.log(`%c ${msgs}`, style)
}
